/* ==========================================================================
   GF Shoppable Blog — theme layer JS (CRO §7) — v5
   Loaded only by sections/gf-shoppable-recipe.liquid when the module
   renders (recipe_products on recipes, related_products fallback on news).

   v5 (18/08/2026, fix A9). Two changes to the ingredient scanner:
   (a) it now runs only when cfg.source === 'recipe'. On stories the
       ingredient region is never built, so the servings stepper and the
       copy-ingredients button cannot attach to editorial bullet lists.
   (b) the region walk stops at H1-H2 instead of H1-H3, so an H3 subtitle
       under the Ingredients heading no longer truncates the scan.
   (c) ING_RE now also matches the Greek term actually used in the EL
       bodies, "συστατικά". The pre-existing "υλικά" never matched a single
       recipe, so on the EL storefront the module had no ingredient region
       at all.
   Product cards, the sticky bar and inline add-to-cart are unaffected by
   both: they never depended on the scanner.

   Modules:
   0. Repositioning      — moves the shoppable module above the comments
      area and the Back-to-blog link to the end of the article (before the
      Related sections). Done at runtime so the core main-article section
      stays untouched; can be ported to Liquid at theme promotion.
   1. Servings adjuster  — hooks the "Serves/Portions" meta item inside the
      article body and rescales ingredient quantities in the DOM.
   2. Copy-ingredients   — button appended after the ingredients list(s).
   3. Mobile sticky bar  — "Shop this recipe/story", scrolls to the module.
      Detects the Shopify theme-preview bar and offsets above it.
   4. Inline add-to-cart — AJAX /cart/add.js from the product cards.

   Analytics: every custom event carries gf_source = 'recipe' | 'story' so
   recipes and news contributions can be read separately vs the 0.14%
   blog-touched CR baseline.
   ========================================================================== */
(function () {
  'use strict';

  var section = document.getElementById('gf-shop-recipe');
  if (!section) return;

  /* ==========================================================
     0. Repositioning
     ========================================================== */
  try {
    var commentsWrap = document.querySelector('.article-template__comment-wrapper');
    if (commentsWrap) commentsWrap.parentNode.insertBefore(section, commentsWrap);
    var backLink = document.querySelector('.article-template__back');
    var articleRoot = document.querySelector('article.article-template');
    if (backLink && articleRoot) articleRoot.appendChild(backLink);
  } catch (e) {}

  var cfg = {};
  try {
    cfg = JSON.parse(document.getElementById('gf-shop-config').textContent);
  } catch (e) { cfg = {}; }

  var articleBody = document.querySelector('.article-template__content') ||
    document.querySelector('.article-template');

  /* ---------------- analytics helpers ---------------- */
  function track(eventName, payload) {
    payload = payload || {};
    if (cfg && cfg.source) payload.gf_source = cfg.source;
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, payload));
    } catch (e) {}
    try {
      if (typeof window.clarity === 'function') window.clarity('event', eventName);
    } catch (e) {}
  }

  /* ==========================================================
     1 + 2. Servings adjuster and quantity scaling
     ========================================================== */
  var SERVES_RE = /^(serves|servings?|portions?|porzioni|personen|portionen|porciones|raciones|μερίδες)/i;
  var ING_RE = /(ingredient|ingredienti|ingr[ée]dient|zutaten|ingredientes|υλικά|συστατικά)/i;

  var qtySpans = [];

  function parseLocaleNumber(str) {
    return parseFloat(String(str).replace(',', '.'));
  }

  var FRACTIONS = { '½': 0.5, '⅓': 1 / 3, '⅔': 2 / 3, '¼': 0.25, '¾': 0.75, '⅛': 0.125 };

  function formatQty(value) {
    var locale = (cfg.locale || 'en');
    var useComma = ['it', 'fr', 'de', 'es', 'el'].indexOf(locale) > -1;
    var whole = Math.floor(value + 1e-9);
    var frac = value - whole;
    var fracMap = [
      [0.25, '¼'], [1 / 3, '⅓'], [0.5, '½'], [2 / 3, '⅔'], [0.75, '¾']
    ];
    for (var i = 0; i < fracMap.length; i++) {
      if (Math.abs(frac - fracMap[i][0]) < 0.04) {
        return (whole > 0 ? whole + ' ' : '') + fracMap[i][1];
      }
    }
    if (Math.abs(frac) < 0.04) return String(whole);
    var rounded = Math.round(value * 10) / 10;
    var out = String(rounded);
    if (useComma) out = out.replace('.', ',');
    return out;
  }

  /* Wrap leading quantity tokens of an element's first text content.
     Handles: "2", "1,5", "1.5", "1 ½", "½", "2-3" */
  var QTY_TOKEN_RE = /^(\s*)((\d+(?:[.,]\d+)?)(\s*[½⅓⅔¼¾⅛])?|[½⅓⅔¼¾⅛])(\s*[-–]\s*(\d+(?:[.,]\d+)?))?/;

  function wrapQtyInNode(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var textNode = walker.nextNode();
    while (textNode && !textNode.nodeValue.trim()) textNode = walker.nextNode();
    if (!textNode) return;

    var m = textNode.nodeValue.match(QTY_TOKEN_RE);
    if (!m || !m[2]) return;

    var raw = m[2];
    var base = 0;
    var numPart = raw.match(/\d+(?:[.,]\d+)?/);
    if (numPart) base += parseLocaleNumber(numPart[0]);
    var fracChar = raw.match(/[½⅓⅔¼¾⅛]/);
    if (fracChar) base += FRACTIONS[fracChar[0]] || 0;
    if (!base) return;

    var base2 = null;
    if (m[6]) base2 = parseLocaleNumber(m[6]); /* range "2-3" */

    var span = document.createElement('span');
    span.setAttribute('data-gf-qty', '');
    span.setAttribute('data-base', String(base));
    if (base2) span.setAttribute('data-base2', String(base2));
    span.textContent = m[2] + (m[5] || '');

    var rest = textNode.nodeValue.slice(m[0].length);
    var lead = document.createTextNode(m[1] || '');
    var restNode = document.createTextNode(rest);
    var parent = textNode.parentNode;
    parent.insertBefore(lead, textNode);
    parent.insertBefore(span, textNode);
    parent.insertBefore(restNode, textNode);
    parent.removeChild(textNode);
    qtySpans.push(span);
  }

  /* Document-order scan: heading matching ING_RE, then every UL/OL that
     follows it (at any nesting depth) until the next H1-H2. Recipe bodies
     wrap everything in one container div, so sibling traversal is not
     reliable. H3 is deliberately NOT a stop level: recipe bodies use H3 for
     ingredient sub-groups ("For the skewers", "For serving") and the section
     that follows the ingredients is always an H2. */
  function findIngredientLists() {
    if (!articleBody) return null;
    var headings = articleBody.querySelectorAll('h1, h2, h3, h4');
    var start = null;
    for (var i = 0; i < headings.length; i++) {
      if (ING_RE.test(headings[i].textContent)) { start = headings[i]; break; }
    }
    if (!start) return null;

    var all = articleBody.querySelectorAll('*');
    var seen = false;
    var lists = [];
    for (var j = 0; j < all.length; j++) {
      var el = all[j];
      if (el === start) { seen = true; continue; }
      if (!seen) continue;
      if (start.contains(el)) continue;
      var inCollected = false;
      for (var k = 0; k < lists.length; k++) {
        if (lists[k].contains(el)) { inCollected = true; break; }
      }
      if (inCollected) continue;
      if (/^H[1-2]$/.test(el.tagName)) break;
      if (el.tagName === 'UL' || el.tagName === 'OL') lists.push(el);
    }
    if (!lists.length) return null;
    return { heading: start, lists: lists };
  }

  /* Stories never carry an ingredient list: gating here keeps the stepper
     and the copy button off editorial bullet lists on /blogs/news. */
  var region = (cfg.source === 'recipe') ? findIngredientLists() : null;

  if (region) {
    region.lists.forEach(function (list) {
      Array.prototype.forEach.call(list.querySelectorAll('li'), wrapQtyInNode);
    });
  }

  /* Serves meta item: primary hook is the recipe meta block (h3 title +
     sibling p with the number); fallback scans any small heading/strong
     whose text matches SERVES_RE, including inline "Serves: 4". */
  function findServesItem() {
    if (!articleBody) return null;
    var candidates = articleBody.querySelectorAll('h2, h3, h4, h5, h6, strong, b');
    for (var i = 0; i < candidates.length; i++) {
      var t = candidates[i].textContent.trim();
      if (!SERVES_RE.test(t)) continue;
      var inlineNum = t.replace(SERVES_RE, '').match(/\d+/);
      var container = candidates[i].parentNode;
      var p = container ? container.querySelector('p') : null;
      if (p && /\d/.test(p.textContent)) return { el: p, base: parseInt(p.textContent.replace(/\D+/g, ''), 10) };
      if (inlineNum) return { el: candidates[i], base: parseInt(inlineNum[0], 10) };
      var sib = candidates[i].nextElementSibling;
      if (sib && /\d/.test(sib.textContent)) return { el: sib, base: parseInt(sib.textContent.replace(/\D+/g, ''), 10) };
    }
    return null;
  }

  var baseServes = null;
  var currentServes = null;

  function applyFactor() {
    var factor = currentServes / baseServes;
    qtySpans.forEach(function (span) {
      var b = parseFloat(span.getAttribute('data-base'));
      var b2 = span.getAttribute('data-base2');
      var txt = formatQty(b * factor);
      if (b2) txt += '-' + formatQty(parseFloat(b2) * factor);
      span.textContent = txt;
      span.classList.toggle('gf-qty--changed', factor !== 1);
    });
  }

  var serves = findServesItem();
  if (serves && serves.base > 0 && qtySpans.length) {
    baseServes = serves.base;
    currentServes = baseServes;
    var stepper = document.createElement('span');
    stepper.className = 'gf-qty-stepper';
    stepper.innerHTML =
      '<button type="button" data-gf-step="-1" aria-label="−">−</button>' +
      '<span class="gf-qty-stepper__value">' + baseServes + '</span>' +
      '<button type="button" data-gf-step="1" aria-label="+">+</button>';
    serves.el.textContent = '';
    serves.el.appendChild(stepper);
    var valueEl = stepper.querySelector('.gf-qty-stepper__value');
    stepper.addEventListener('click', function (ev) {
      var btn = ev.target.closest('[data-gf-step]');
      if (!btn) return;
      var next = currentServes + parseInt(btn.getAttribute('data-gf-step'), 10);
      if (next < 1 || next > 48) return;
      currentServes = next;
      valueEl.textContent = next;
      applyFactor();
      track('gf_blog_servings_adjust', { gf_servings: next, gf_base: baseServes });
    });
  }

  /* ==========================================================
     2b. Copy-ingredients button
     ========================================================== */
  if (region) {
    var lastList = region.lists[region.lists.length - 1];
    var wrap = document.createElement('div');
    wrap.className = 'gf-copy-wrap';
    wrap.innerHTML =
      '<button type="button" class="gf-copy-btn">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">' +
      '<rect x="9" y="9" width="12" height="12" rx="2"/><path d="M5 15V5a2 2 0 0 1 2-2h10"/></svg>' +
      '<span>' + (cfg.copyLabel || 'Copy ingredient list') + '</span></button>' +
      '<p class="gf-copy-toast" role="status">' + (cfg.copiedText || 'Copied.') +
      ' <a href="#gf-shop-recipe">' + (cfg.copiedCta || 'Or have them delivered from Greece →') + '</a></p>';
    lastList.parentNode.insertBefore(wrap, lastList.nextSibling);

    var toast = wrap.querySelector('.gf-copy-toast');

    var collectLines = function () {
      var lines = [];
      region.lists.forEach(function (list) {
        Array.prototype.forEach.call(list.querySelectorAll('li'), function (li) {
          var t = (li.innerText || li.textContent || '').trim();
          if (t) lines.push('- ' + t.replace(/\s+/g, ' '));
        });
      });
      return lines;
    };

    var legacyCopy = function (text) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.top = '-1000px';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      document.body.removeChild(ta);
      return ok;
    };

    wrap.querySelector('.gf-copy-btn').addEventListener('click', function () {
      var lines = collectLines();
      if (!lines.length) return;
      var text = lines.join('\n');
      function done() {
        toast.classList.add('is-visible');
        track('gf_blog_copy_ingredients', { gf_lines: lines.length });
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done, function () {
          legacyCopy(text);
          done();
        });
      } else {
        legacyCopy(text);
        done();
      }
    });
    toast.querySelector('a').addEventListener('click', function (ev) {
      ev.preventDefault();
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ==========================================================
     3. Mobile sticky bar
     ========================================================== */
  var sticky = document.getElementById('gf-sticky-bar');
  if (sticky) {
    var shopVisible = false;
    var update = function () {
      var scrolled = window.scrollY > 400;
      sticky.classList.toggle('is-visible', scrolled && !shopVisible);
    };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        shopVisible = entries[0].isIntersecting;
        update();
      }).observe(section);
    }
    window.addEventListener('scroll', update, { passive: true });
    update();

    /* Shopify theme-preview bar sits fixed at the bottom with a high
       z-index and would cover the sticky bar during theme testing.
       Offset above it when present (it loads late, hence the retries). */
    var previewBarOffset = function () {
      var pb = document.getElementById('preview-bar-iframe') ||
        document.querySelector('iframe[src*="preview_bar"]');
      if (pb && pb.offsetHeight) {
        sticky.style.bottom = pb.offsetHeight + 'px';
      } else if (pb) {
        sticky.style.bottom = '72px';
      }
    };
    previewBarOffset();
    setTimeout(previewBarOffset, 1200);
    setTimeout(previewBarOffset, 3500);

    sticky.querySelector('.gf-sticky-bar__btn').addEventListener('click', function () {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      track('gf_blog_sticky_shop_click', {});
    });
  }

  /* ==========================================================
     4. Inline add-to-cart
     ========================================================== */
  function refreshCartUI() {
    try { if (typeof window.refreshCart === 'function') window.refreshCart(); } catch (e) {}
    try {
      fetch(window.location.pathname + '?section_id=cart-icon-bubble')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var holder = document.createElement('div');
          holder.innerHTML = html;
          var fresh = holder.querySelector('#cart-icon-bubble') || holder.firstElementChild;
          var target = document.getElementById('cart-icon-bubble');
          if (fresh && target) target.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    } catch (e) {}
  }

  section.addEventListener('click', function (ev) {
    var btn = ev.target.closest('.gf-shop-card__atc');
    if (!btn || btn.disabled) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    btn.disabled = true;
    var addUrl = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
    fetch(addUrl.replace('.js.js', '.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        btn.classList.add('is-added');
        btn.textContent = cfg.addedLabel || 'Added ✓';
        track('gf_blog_shoppable_atc', {
          gf_variant_id: variantId,
          gf_product_handle: btn.getAttribute('data-handle') || ''
        });
        refreshCartUI();
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.textContent = cfg.atcLabel || 'Add to cart';
          btn.disabled = false;
        }, 2400);
      })
      .catch(function () {
        btn.disabled = false;
      });
  });
})();
